import {
  BFF_ROUTES,
  FunnelSnapshotResponseSchema,
  type FunnelSnapshotResponse,
} from '@rheora/enrollment-contract';

import { bffGet } from './bff-client';

/**
 * Typed fetcher for the funnel REHYDRATE (`GET /bff/funnel`). Thin: request +
 * validate against the shared contract schema. Pages/components call the
 * `funnel.queries` hooks, never this.
 *
 * ── WHAT IT FIXES ──────────────────────────────────────────────────────────
 * Refreshing the browser mid-funnel used to lose everything. The BFF has held the
 * state server-side all along (keyed by the `enr_sid` cookie); there was simply no
 * endpoint to read it back. This is the read.
 *
 * ── NO CAPTCHA TOKEN, DELIBERATELY ─────────────────────────────────────────
 * `withCaptcha` is NOT set. `/bff/funnel` is not in the contract's `CAPTCHA_ROUTES`
 * and matches no server-side sensitive pattern — a CAPTCHA on a page-load rehydrate
 * would break every refresh, which is the bug. The session cookie rides via
 * `credentials: 'same-origin'` (see bff-client) and is the only capability involved.
 *
 * ── A 401 IS AN ANSWER, NOT AN OUTAGE ──────────────────────────────────────
 * With no session the BFF answers `401`, which `bffGet` surfaces as a `BffError`
 * carrying the status. Callers read it with `isSessionExpired` and treat it as
 * "hydrated, empty". ⚠️ It must NEVER trigger a session mint: only the meter
 * sub-flows legitimately create a session, and minting here would turn every deep
 * link into an anonymous entry point (bff-client.ts — `isSessionExpired`).
 */
export async function getFunnelSnapshot(): Promise<FunnelSnapshotResponse> {
  return bffGet(BFF_ROUTES.funnel, FunnelSnapshotResponseSchema);
}
